import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import CardMemberAvatar from '@atoms/CardMemberAvatar';
import ShareIcon from '@icons/ShareIcon';
import { LinkSmall } from '@styled';
import { mediaQueries } from '@general/breakpoints';

const Container = styled.div`
    height: 100%;
    min-height: 350px;
    padding-bottom: 68px;

    @media ${mediaQueries.sm} {
        min-height: 360px;
    }

    @media ${mediaQueries.lg} {
        min-height: 420px;
    }

    @media ${mediaQueries.xl} {
        min-height: 430px;
    }
`;

const NewMemberCard = ({
    firstName,
    lastName,
    fullName,
    companyID,
    companyName,
    title,
    designations,
    displayLocation,
    businessType,
    photoURL,
    url,
    onClick,
}) => {
    const history = useHistory();

    return (
        <Container className="card mb-0">
            <div className="d-flex justify-content-center mt-4">
                <CardMemberAvatar
                    firstName={firstName}
                    lastName={lastName}
                    fullName={fullName}
                    photoURL={photoURL}
                    sizeDesktop={120}
                />
            </div>

            <div className="py-0 card-block">
                <a href={url} onClick={() => onClick(url)} onKeyDown={() => onClick(url)} className="profile-name-link">
                    <h3 className="mt-3 mb-0 text-center member-name display6 bold">
                        {fullName}
                        {designations && <span>{designations}</span>}
                    </h3>
                </a>
                <p className="mt-2 mb-0 text-center display8 secondary member-title">{title}</p>
                <p className="mt-2 mb-0 text-center display8 secondary member-title">{displayLocation}</p>

                {(companyID || companyName) && (
                    <LinkSmall
                        href={`/company/profile/${companyID}`}
                        className="d-inline-block mt-2 text-center text-md w-100"
                        onClick={e => {
                            onClick();

                            // History is undefined if called from within a modal
                            if (!history) {
                                return;
                            }

                            e.preventDefault();
                            history.push(`/company/profile/${companyID}`, { state: { inApp: true } });
                        }}
                    >
                        {companyName + (businessType && businessType.length > 0 ? ` (${businessType[0]})` : '')}
                    </LinkSmall>
                )}
            </div>

            <div className="p-3 card-icons w-100 d-flex justify-content-start align-items-center">
                <ShareIcon title={fullName} url={url} classNames="mr-3" />
            </div>
        </Container>
    );
};

NewMemberCard.propTypes = {
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    fullName: PropTypes.string,
    companyID: PropTypes.number,
    companyName: PropTypes.string,
    title: PropTypes.string,
    designations: PropTypes.string.isRequired,
    displayLocation: PropTypes.string,
    businessType: PropTypes.array.isRequired,
    photoURL: PropTypes.string,
    onClick: PropTypes.func,
    url: PropTypes.string,
};

export default NewMemberCard;
